export const START_TIME_NOT_VALID = "Start time cannot be in the future";
export const HOURS_NOT_VALID = "Hours not valid!";
export const MINUTES_NOT_VALID = "Minutes not valid!";
export const TOKEN_SUPPLY_MAX_NOT_VALID =
  "You reached the maximum token supply!";
export const TOKEN_SUPPLY_NOT_VALID = "Token supply not valid!";
export const MAX_VALUE =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";
export const TOKEN_SUPPLY_REQUIRED = "Token supply is required!";
